import React from "react";
import { Link } from "react-router-dom";
import { Printer, ArrowLeft, PawPrint } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { QRCard } from "@/components/QRCard";
import { PRICING } from "@/lib/pricing";

const Row = ({ label, value, italic }) => (
  <tr>
    <td className={`py-2 px-4 border-t border-[#2C6E49]/40 text-[12pt] ${italic ? "italic font-bold" : ""}`} style={{ fontFamily: italic ? "Fraunces, serif" : "Nunito, sans-serif" }}>
      {label}
    </td>
    <td className="py-2 px-4 border-t border-l border-[#2C6E49]/40 text-[12pt] font-bold text-center">{value}</td>
  </tr>
);

function PriceTable({ title, block }) {
  return (
    <div className="rounded-2xl overflow-hidden border-2 border-[#2C6E49]">
      <div className="bg-[#2C6E49] text-[#F8F0DC] text-center py-2" style={{ fontFamily: "Fraunces, serif" }}>
        <span className="text-[15pt] font-bold tracking-wide">{title}</span>
      </div>
      <table className="w-full bg-[#F8F0DC]">
        <thead>
          <tr className="bg-[#F5EBD6]">
            <th className="py-2 px-4 text-[12pt] font-bold text-[#2C6E49] text-left" style={{ fontFamily: "Fraunces, serif" }}>TIPO DE SERVIÇO</th>
            <th className="py-2 px-4 text-[12pt] font-bold text-[#2C6E49] text-center border-l border-[#2C6E49]/40" style={{ fontFamily: "Fraunces, serif" }}>VALOR (R$)</th>
          </tr>
        </thead>
        <tbody>
          <Row label="Avulso" value={block.avulso.price.toString()} />
          <tr>
            <td colSpan="2" className="border-t border-[#2C6E49]/40 pt-3 pb-1 px-4 text-[12pt] italic font-bold text-[#2C6E49]" style={{ fontFamily: "Fraunces, serif" }}>
              Pacotes Semanais:
            </td>
          </tr>
          {block.semanal.map((s) => (
            <tr key={s.key}>
              <td className="py-1 px-6 text-[12pt]">{s.label.split(" · ")[1]}</td>
              <td className="py-1 px-4 text-[12pt] font-bold text-center border-l border-[#2C6E49]/40">
                {s.price} <span className="font-normal">({s.unit})</span>
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan="2" className="border-t border-[#2C6E49]/40 pt-3 pb-1 px-4 text-[12pt] italic font-bold text-[#2C6E49]" style={{ fontFamily: "Fraunces, serif" }}>
              Planos Mensais:
            </td>
          </tr>
          {block.mensal.map((s) => (
            <tr key={s.key}>
              <td className="py-1 px-6 text-[12pt]">{s.label.split(" · ")[1]}</td>
              <td className="py-1 px-4 text-[12pt] font-bold text-center border-l border-[#2C6E49]/40">
                {s.price} <span className="font-normal">({s.unit})</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function PanfletoPrecos() {
  return (
    <div className="min-h-screen bg-neutral-200 py-8 px-4" data-testid="panfleto-precos">
      <div className="no-print max-w-3xl mx-auto flex items-center justify-between mb-6">
        <Link to="/panfletos" className="inline-flex items-center gap-1 text-[#2C6E49] font-bold text-sm">
          <ArrowLeft size={16} /> Voltar
        </Link>
        <button onClick={() => window.print()} data-testid="print-precos" className="inline-flex items-center gap-2 rounded-full bg-[#2C6E49] text-[#F8F0DC] px-5 py-2.5 font-bold text-sm hover:bg-[#1F5F3F]">
          <Printer size={16} /> Imprimir / Salvar PDF
        </button>
      </div>

      <div className="print-page grain-overlay">
        <div className="paw-bg absolute inset-y-0 right-0 w-16 opacity-40" />

        {/* Header centered */}
        <div className="flex flex-col items-center relative z-10">
          <div className="flex items-center gap-4">
            <LogoMark height={120} />
            <PawPrint size={44} className="text-[#8B5A2B]" />
          </div>
          <h1 className="mt-5 text-[#2C6E49] font-bold text-center" style={{ fontFamily: "Fraunces, serif", fontSize: "30pt", letterSpacing: "-0.02em" }}>
            TABELA DE VALORES — DOG WALKER
          </h1>
        </div>

        {/* Tables */}
        <div className="mt-8 space-y-6 relative z-10">
          <PriceTable title="PASSEIOS DE 30 MINUTOS" block={PRICING["30"]} />
          <PriceTable title="PASSEIOS DE 1 HORA" block={PRICING["60"]} />
        </div>

        {/* Footer strip */}
        <div className="mt-10 flex items-center justify-between gap-4 border-t-4 border-[#4A8F5F] pt-4 relative z-10">
          <div>
            <div style={{ fontFamily: "Fraunces, serif" }} className="text-[#2C6E49] font-bold text-[13pt]">
              📍 Vila Mathias — Santos/SP
            </div>
            <div className="text-[#1a1a1a] text-[11pt]">WhatsApp: (13) 99115-7896</div>
          </div>
          <QRCard compact />
        </div>
      </div>
    </div>
  );
}
